import LayerList from "./LayerList";
import ManMadeSlopeInfoList from "./ManMadeSlopeInfoList";
import DistrictLayerList from "./DistrictLayerList_new";
import config_base from "./config_GPTools";

export default function(baseUrl) {
  let gisUrl = `${baseUrl}/server/rest/services`;
  let rainContourBaseUrl = `${baseUrl}/GInfoMap/RainContour`;
  return {
    baseUrl,
    gisUrl,
    useEsriProxy: false,
    serverUrl: `${baseUrl}/server`,
    portalUrl: `${baseUrl}/portal`,
    webSrvUrl: baseUrl + "/ginfo_srv/api/",
    fileSrvUrl: `${baseUrl}/ginfo_srv/api/`,
    ginfo3dQueueUrl: `${baseUrl}/3dginfodata/`,
    printSrvUrl: `${gisUrl}/PrintTool/PythonExportWebMap/GPServer/PythonExportWebMap`,
    orginPrintSrvUrl: `${gisUrl}/PrintTool/ProxyPrint/GPServer/ProxyPrint`,
    slopeReportUrl: `${baseUrl}/GInfoMap/openSlopeReport.aspx`,
    exportPdfUrl: `${baseUrl}/GInfoMap/export.aspx`,
    LDS_WEB_SERVICE_URL: baseUrl + "/ginfo_srv/api/WebAPI/LDS/",
    AvailLayerList: LayerList(gisUrl),
    ManMadeSlopeInfoList: ManMadeSlopeInfoList(baseUrl),
    DistrictLayerList: DistrictLayerList(gisUrl),
    LDS_SENSORS_ITEM_ID: "8c2f499be19c4c748827f7a748d614f1",
    websiteTitle: "GEOTECHNICAL INFORMATION INFRASTRUCTURE",
    authorizePage: "/GInfoInt",
    gpToolUrls: config_base(gisUrl),
    oneHourRainfall: `${rainContourBaseUrl}/Large_Contour01Hr.png`,
    twenty4HourRainfall: `${rainContourBaseUrl}/Large_Contour24Hr.png`,
    rainfallLastUpdate: `${rainContourBaseUrl}/LastUpdate.txt`,
    raingaugeLayer: `${gisUrl}/Overlay/Raingauge/MapServer/0`,
  };
}
